<template>
  <tr>
    <td>
      <img src="https://placeimg.com/640/480/any">
      <ul>
        <li>Bureau 148</li>
        <li>Sofradom</li>
        <li>20 rue de l'Opéra 75009 Paris</li>
      </ul>
    </td>
    <td class="v-align-middle">
      <div>Disponible</div>
      <ul>
        <li>Bon de réservation pour Septembre</li>
        <li>Location ponctuelle la 16/08/2016</li>
      </ul>
    </td>
    <td class="v-align-middle">
      <span>28m²</span>
    </td>
    <td>
      <span>600€ HT</span>
    </td>
  </tr>
</template>

<script type="text/babel">
  export default {}
</script>

<style lang="scss" scoped>
  @import '~pages_sass/_var.scss';

  tr {
    td {
      &:first-child {
        ul {
          color: #666;
          li {
            line-height: initial;
            &:nth-child(2) {
              font-size: 0.7rem;;
            }
            &:nth-child(3) {
              font-size: 0.7rem;;
            }
          }
        }
        &::before {
          display: none !important;
        }
      }
      &:nth-child(2) {
        ul {
          li {
            line-height:initial;
            font-size: 0.7rem;
          }
        }
      }
    }
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  img {
    max-height: 50px;
    margin: 0 10px 0 5px;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// client/components/LongTermLocationsList/Item.vue